<form [formGroup]="roleForm">
    <div class="col-sm-10 controls-input">
        <div class="gap"></div>
        <label class="mdc-text-field mdc-text-field--fullwidth fids-line-ripple text-material mb-0">
            <input id="name" class="mdc-text-field__input  input-aligner txt-spacer" type="text" maxlength="256"
                matInput (paste)="on_paste_omit_special_char($event,'name')" (keypress)="omit_special_char($event)"
                formControlName="name" required aria-label="name"
                aria-controls="my-helper-id" aria-describedby="my-helper-id">
            <span class="mdc-floating-label  minus-margin">Name</span>
            <div class="mdc-line-ripple"></div>
        </label>
        <div class="mdc-text-field-helper-line"></div>
    </div>

    <div class="col-sm-10 controls-input">
        <div class="gap"></div>
        <label class="mdc-text-field mdc-text-field--fullwidth fids-line-ripple text-material mb-0">
            <input id="description" class="mdc-text-field__input  input-aligner txt-spacer" type="text" maxlength="1000"
                matInput (paste)="on_paste_omit_special_char($event,'description')" (keypress)="omit_special_char($event)"
                formControlName="description" required aria-label="description"
                aria-controls="my-helper-id" aria-describedby="my-helper-id">
            <span class="mdc-floating-label  minus-margin">Description</span>
            <div class="mdc-line-ripple"></div>
        </label>
        <div class="mdc-text-field-helper-line"></div>
    </div>

    <div class="col-sm-12 m-b-10 p-l-5">
        <div class="mdc-form-field formfield-material">
            <div class="mdc-checkbox">
                <div class="col-sm-12 pull-left" role="checkbox" tabindex="0" [attr.aria-checked]="isActive ? 'true' : 'false'"
                    (click)="isActive = !isActive; onCheckChange(isActive)"
                    (keydown.enter)="isActive = !isActive; onCheckChange(isActive)"
                    (keydown.space)="$event.preventDefault(); isActive = !isActive; onCheckChange(isActive)">
                    <span *ngIf="isActive" class="checkbox-item-font ey-dna-icon-Selected_Checkbox"></span>
                    <span *ngIf="!isActive" class="checkbox-item-font ey-dna-icon-Unselected_Checkbox"></span>
                </div>
            </div>
            <label style="padding-top: 5px; padding-left: 0px;" for="checkbox-1">Active</label>
        </div>
    </div>

    <div class="col-sm-12 m-b-10 fids-o-p-l controls-input">
        <app-treeview title="Features">
            <!-- Search filter -->
            <div class="row row-filter">
                <div class="col-sm-12 controls-input">
                    <label class="mdc-text-field mdc-text-field--fullwidth fids-line-ripple text-material mb-0">
                        <input class="mdc-text-field__input input-aligner txt-spacer" aria-label="search"
                            type="text" [(ngModel)]="filterText" [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="applyFilter()" />
                        <span class="mdc-floating-label minus-margin">Search</span>
                        <div class="mdc-line-ripple"></div>
                    </label>
                    <div class="mdc-text-field-helper-line"></div>
                </div>
            </div>

            <!-- Select All -->
            <div class="row select-all-row">
                <div class="col-sm-12 tree-item-header" role="checkbox" tabindex="0" [attr.aria-checked]="allIndeterminate ? 'mixed' : (allChecked ? 'true' : 'false')"
                    aria-label="Select all permissions" (click)="toggleAll()"
                    (keydown.enter)="toggleAll()" (keydown.space)="$event.preventDefault(); toggleAll()">
                    <span *ngIf="allChecked && !allIndeterminate" class="tree-item-font ey-dna-icon-Selected_Checkbox"></span>
                    <span *ngIf="!allChecked && !allIndeterminate" class="tree-item-font ey-dna-icon-Unselected_Checkbox"></span>
                    <span *ngIf="allIndeterminate" class="tree-item-font ey-dna-icon-Checkbox_Half"></span>
                    <span class="form-check-label">All</span>
                </div>
            </div>

            <div class="dropdown-divider"></div>

            <!-- Mat Tree -->
            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="permission-tree">
                <!-- Leaf node -->
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [matTreeNodePaddingIndent]="36">
                    <div class="form-inline row-item">
                        <span class="toggle-placeholder-leaf"></span>
                        <div class="form-check" [class.disabled-permission]="node.disabled"
                            role="checkbox" tabindex="0" [attr.aria-checked]="node.indeterminate ? 'mixed' : (node.checked ? 'true' : 'false')" [attr.aria-disabled]="node.disabled"
                            [attr.aria-label]="node.displayName"
                            (click)="!node.disabled && toggleNode(node)"
                            (keydown.enter)="!node.disabled && toggleNode(node)"
                            (keydown.space)="$event.preventDefault(); !node.disabled && toggleNode(node)">
                            <span *ngIf="node.checked && !node.disabled" class="tree-item-font ey-dna-icon-Selected_Checkbox"></span>
                            <span *ngIf="!node.checked && !node.indeterminate && !node.disabled" class="tree-item-font ey-dna-icon-Unselected_Checkbox"></span>
                            <span *ngIf="node.indeterminate && !node.disabled" class="tree-item-font ey-dna-icon-Checkbox_Half"></span>
                            <span *ngIf="node.disabled" class="tree-item-font ey-dna-icon-Disabled_Checkbox"></span>
                            <span class="form-check-label">{{node.displayName}}</span>
                        </div>
                    </div>
                </mat-tree-node>

                <!-- Parent node -->
                <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding [matTreeNodePaddingIndent]="36">
                    <div class="form-inline row-item">
                        <i role="button" tabindex="0" [attr.aria-label]="(treeControl.isExpanded(node) ? 'Collapse ' : 'Expand ') + node.displayName"
                            (click)="treeControl.toggle(node)"
                            (keydown.enter)="treeControl.toggle(node)"
                            (keydown.space)="$event.preventDefault(); treeControl.toggle(node)"
                            class="fa toggle-icon"
                            [class.fa-plus]="!treeControl.isExpanded(node)"
                            [class.fa-minus]="treeControl.isExpanded(node)"></i>
                        <div class="form-check" [class.disabled-permission]="node.disabled"
                            role="checkbox" tabindex="0" [attr.aria-checked]="node.indeterminate ? 'mixed' : (node.checked ? 'true' : 'false')" [attr.aria-disabled]="node.disabled"
                            [attr.aria-label]="node.displayName"
                            (click)="!node.disabled && toggleNode(node)"
                            (keydown.enter)="!node.disabled && toggleNode(node)"
                            (keydown.space)="$event.preventDefault(); !node.disabled && toggleNode(node)">
                            <span *ngIf="node.checked && !node.indeterminate" class="tree-item-font ey-dna-icon-Selected_Checkbox"></span>
                            <span *ngIf="!node.checked && !node.indeterminate" class="tree-item-font ey-dna-icon-Unselected_Checkbox"></span>
                            <span *ngIf="node.indeterminate" class="tree-item-font ey-dna-icon-Checkbox_Half"></span>
                            <span class="form-check-label">{{node.displayName}}</span>
                        </div>
                    </div>
                </mat-tree-node>
            </mat-tree>
        </app-treeview>
    </div>

    <div class="col-sm-12 m-b-10">
        <div class="row m-r-0 m-l-0">
            <div class="col pl-0">
                <button class="mdc-button ripple-material" mat-stroked-button (click)="close()" type="button">
                    <span class="mdc-button__ripple"></span> Cancel
                </button>
                <button class="mdc-button ml-3 fids-tooltip mdc-button--raised mdc-button--sharp ripple-material"
                    mat-stroked-button [disabled]="!roleForm.valid"
                    (click)="save()" type="submit" #submitButton>
                    <span class="mdc-button__ripple"></span> Submit
                </button>
            </div>
        </div>
    </div>
</form>
